import React from "react";
import TripIssue from "./tripIssue";
import { connection, flightStatusIndicatorStyle, stringToUppercase } from "../../js/lib/filters";
import { hopHasConnectionIssues } from "../../js/lib/trip";
import { Issue } from "../../js/headersegment/interfaces";

interface TripFlightConnectionProps {
    trip: any;
    awayContactPointsMap: any;
    hop: any;
}

const TripFlightConnection: React.FC<TripFlightConnectionProps> = ({ trip, awayContactPointsMap, hop }) => {

    const renderConnectionStatusBox = (statusIndicator: string, statusMessage: string) => (
        <div className={flightStatusIndicatorStyle(statusIndicator)}>
          {stringToUppercase(statusMessage)}
        </div>
      );

    return (<>
        {hopHasConnectionIssues(hop) && (
            <div>
                {hop.connectionIssues.map((issue: Issue, index: number) => (
                    <div key={index}>
                        <div>
                            <TripIssue trip={trip} awayContactPointsMap={awayContactPointsMap} parentIssue={issue}></TripIssue>
                        </div>
                    </div>
                ))}
            </div>
        )}
        <div className="row separator"></div>
        <div className="row connection-wrapper">
            <div className="col-md-12 connection">
            <div className="row">
                <div className="col-md-6 db-secondary-header hidden-sm hidden-xs">
                    {connection(hop.connection, 'in', false)}
                </div>
                <div className="col-md-6 db-secondary-header visible-sm visible-xs">
                    {connection(hop.connection, 'in', true)}
                </div>
                <div className="col-md-6">
                <div className="connection-status-box connection-status-box-hxs hidden-sm hidden-xs">
                    {renderConnectionStatusBox(hop.connection?.statusIndicator, hop.connection?.statusMessage)}
                </div>
                <div className="connection-status-box visible-sm visible-xs">
                    {renderConnectionStatusBox(hop.connection?.statusIndicator, hop.connection?.statusMessage)}
                </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="col-md-6 connection-label hidden-sm hidden-xs">CONNECTION TIME</div>
                    <div className="col-md-6 connection-label connection-label-xs visible-sm visible-xs">CONN. TIME</div>
                    <div className="col-md-6 db-text">{connection(hop.connection, 'connectionTime')}</div>
                </div>
                <div className="col-md-6">
                    <div className="col-md-12 min-con-time">{connection(hop.connection, 'minConnectionTime')}</div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="col-md-6 connection-label hidden-sm hidden-xs">ARRIVAL GATE</div>
                    <div className="col-md-6 connection-label connection-label-xs visible-sm visible-xs">ARR. GATE</div>
                    <div className="col-md-6 db-text">{connection(hop.connection, 'arrivalGate')}</div>
                </div>
                <div className="col-md-6">
                    <div className="col-md-6 connection-label hidden-sm hidden-xs">DEPARTURE GATE</div>
                    <div className="col-md-6 connection-label connection-label-xs visible-sm visible-xs">DEP. GATE</div>
                    <div className="col-md-6 db-text">{connection(hop.connection, 'departureGate')}</div>
                </div>
            </div>
            </div>
        </div>
    </>);
}

export default TripFlightConnection;